// Shared between Landing.jsx (captures ?ref=CODE) and Pricing.jsx (prefills the referral input
// from it) — a plain localStorage.setItem has no built-in TTL, so the expiry is stored alongside
// the code and checked on every read.
const STORAGE_KEY = "flowtweaks_referral";
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export function storeReferralCode(code) {
  const trimmed = (code || "").trim().toUpperCase();
  if (!trimmed) return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ code: trimmed, expiresAt: Date.now() + THIRTY_DAYS_MS })
    );
  } catch {
    // localStorage unavailable (private mode, etc.) — referral capture just doesn't persist
  }
}

export function getStoredReferralCode() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return "";
    const { code, expiresAt } = JSON.parse(raw);
    if (!code || !expiresAt || Date.now() > expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return "";
    }
    return code;
  } catch {
    return "";
  }
}
